import { render, staticRenderFns } from "./zyk.vue?vue&type=template&id=cc21396a&scoped=true"
import script from "./zyk.vue?vue&type=script&lang=js"
export * from "./zyk.vue?vue&type=script&lang=js"
import style0 from "./zyk.vue?vue&type=style&index=0&id=cc21396a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc21396a",
  null
  
)

export default component.exports